import { configWithTokenId , configNoHeadersV2  } from '@api/constructor-api'

function userInfoHandler(payload) {
  return configWithTokenId((API) => {
    if((payload.restaurantUUID != null && payload.restaurantUUID != 'null') && (payload.branchUUID != null && payload.branchUUID != 'null'))
      return API.get(`info?restaurantUUID=${payload.restaurantUUID}&branchUUID=${payload.branchUUID}`)
    throw 'Not Empty Data'
  })
}

function userProfileHandler(payload) {
  return configWithTokenId((API) => {
    if(payload.restaurantUUID != null && payload.restaurantUUID != 'null')
      return API.put('info', payload);
    throw 'Not Empty Data'
  });
}

function userUploadImageHandler({ image, restaurantUUID }) {
  return configWithTokenId((API) => {
    let formData = new FormData();
    formData.append('image', image);
    formData.append('restaurantUUID', restaurantUUID);
    if(restaurantUUID)
      return API.patch('/info/upload-profile-image', formData);
    throw 'Not Empty Data'
  });
}

function phoneAndLineMatchCheck({ restaurantUUID ,phoneNumber,phoneCountryCode,recaptchaToken }) {
  return configNoHeadersV2(async(API) => {
    return API.get(`auth/check-phone?phoneNumber=${phoneNumber}&recaptchaToken=${recaptchaToken}&phoneCountryCode=${phoneCountryCode}&restaurantUUID=${restaurantUUID}`)
  })
}

function changePhoneHandler(payload) {
  return configWithTokenId((API) => {
    return API.patch(`auth/validate/change-phone`,payload)
  })
}

function getMyCardQRCode(payload) {
  return configWithTokenId((API) => {
    return API.post(`member-qr/generate`, payload)
  })
}

export {
  userInfoHandler,
  userProfileHandler,
  userUploadImageHandler,
  phoneAndLineMatchCheck,
  changePhoneHandler,
  getMyCardQRCode
}